module.exports = __webpack_public_path__ + "img/change_password.42463563.svg";